import { Component, OnInit } from '@angular/core';
import { Account } from '../../models/account';
import { Router } from '@angular/router';
import {AccountService} from "../../services/account.service";

@Component({
    selector: 'account-list',
    templateUrl: 'account-list.component.html',
    styleUrls: ['account-list.component.css'],
    moduleId: module.id
})
export class AccountListComponent implements OnInit{
    accounts: Account[];
    loading: boolean = true;
    accountRole = "";
    constructor(
        private accountService: AccountService,
        private router: Router
    ) { };
    getAccounts(): void {
        this.accountService.getAccounts().then(accounts => {
            this.accounts = accounts.sort((a, b) => {
                return a.name.localeCompare(b.name);
            });
            this.loading = false;
        })
    }

    ngOnInit(): void {
        this.getAccounts();
    };
    // gotoDetail(user: User): void {
    //     this.router.navigate(['/users', user.id]);
    // };
}



// WEBPACK FOOTER //
// ./src/app/components/account-list/account-list.component.ts